import { DateRange } from '@mui/x-date-pickers-pro/models';
import dayjs, { Dayjs } from 'dayjs';
import { getDefaultDateRanges } from '../../../../components/DateRangePicker';
import CustomDateRangePicker from '../../../../components/DateRangePicker';

export type ReportingCriteriaDataRangePickerProps = {
    onChange(startDate?: Date, endDate?: Date): void;
    startDate: Date;
    endDate: Date;
    minDate?: Date;
    maxDate?: Date;
};

export default function ReportingCriteriaDataRangePicker(props: ReportingCriteriaDataRangePickerProps) {
    const { onChange, startDate, endDate, minDate, maxDate } = props;

    const handleDateRangeChange = (newDateRange: DateRange<Dayjs>): void => {
        if (newDateRange[0] && newDateRange[1]) {
            onChange(newDateRange[0].toDate(), newDateRange[1].toDate());
        }
    };

    return (
        <CustomDateRangePicker
            label="Date Range"
            ranges={getDefaultDateRanges({ maxDate })}
            disableFuture={true}
            minDate={minDate ? dayjs(minDate) : undefined}
            maxDate={maxDate ? dayjs(maxDate) : undefined}
            value={[dayjs(startDate), dayjs(endDate)]}
            onChange={handleDateRangeChange}
            width="100%"
        />
    );
}
